// Storage keys
export const ACCESS_TOKEN: string = 'accessToken';
export const ACCESS_TOKEN_EXPIRY: string = 'accessTokenExpiry';
export const USER_DETAIL_KEY: string = 'userDetail';
export const CONVERSATION_ID: string = 'converseId';
export const CURRENT_SELECTION: string = 'currentSelection';

// Event Id's for pub-sub
export const EVENT_ID_BULLETIN_LIST: string = 'BULLETIN_LIST';
export const EVENT_ID_LAYOUT_TEMPLATE: string = 'PUBLISH_LAYOUT_TEMPLATE';
export const EVENT_ID_DATA_NLQ: string = 'PUBLISH_DATA_NLQ';
export const EVENT_ID_CHART_DATA: string = 'CHART_DATA';
export const EVENT_ID_REMOVE_WIDGET: string = 'REMOVE_WIDGET';
export const EVENT_ID_VIEW_SUMMARY: string = 'VIEW_SUMMARY';
export const EVENT_ID_MAX_VIEW: string = 'MAX_VIEW';